import { render, staticRenderFns } from "./rInvestProfile.vue?vue&type=template&id=6a1d4a07&scoped=true&"
import script from "./rInvestProfile.vue?vue&type=script&lang=ts&"
export * from "./rInvestProfile.vue?vue&type=script&lang=ts&"
import style0 from "./rInvestProfile.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./rInvestProfile.vue?vue&type=style&index=1&id=6a1d4a07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1d4a07",
  null
  
)

export default component.exports